import { z } from 'zod';
import { identificationType, withIdentificationCheck } from './common.js';
/**
 * Tipos de comprobante con términos y condiciones propios (Configuración → Términos y condiciones).
 * Equivalen a las 6 pestañas del sistema anterior: invoice→FE, ticket→TE, nc→NC, nd→ND, simple→FEC
 * (el "simplificado" del sistema anterior es la factura de compra) y quotation→quote.
 */
export const TERMS_KEYS = ['FE', 'TE', 'NC', 'ND', 'FEC', 'quote'];
export const TERMS_LABELS = {
    FE: 'Factura',
    TE: 'Tiquete',
    NC: 'Nota de crédito',
    ND: 'Nota de débito',
    FEC: 'Factura de compra',
    quote: 'Cotización',
};
export const TERMS_MAX_LENGTH = 4000;
const termsText = z.string().trim().max(TERMS_MAX_LENGTH).nullable().optional();
/**
 * Actualiza los términos por tipo: solo cambian los tipos enviados; un texto vacío (o null) quita los de ese tipo.
 */
export const updateDocumentTermsInput = z
    .object({
    FE: termsText,
    TE: termsText,
    NC: termsText,
    ND: termsText,
    FEC: termsText,
    quote: termsText,
})
    .strict();
/**
 * Términos que se proponen al crear un comprobante: los del tipo, o —si el tipo no tiene— los de la factura (en las
 * facturas de compra) y, por último, el texto general de la compañía. Un texto vacío no cuenta.
 */
export function resolveTerms(key, documentTerms, defaultTerms) {
    const pick = (v) => (v?.trim() ? v.trim() : null);
    return pick(documentTerms?.[key]) ?? (key === 'FEC' ? pick(documentTerms?.FE) : null) ?? pick(defaultTerms);
}
export const companyBase = z.object({
    legalName: z.string().trim().min(2, 'Requerido').max(160),
    tradeName: z.string().trim().max(160).nullable().optional(),
    identificationType,
    identification: z.string().trim().regex(/^\d+$/, 'Solo números'),
    email: z.email('Correo inválido').trim().toLowerCase(),
    phone: z
        .string()
        .trim()
        .regex(/^\d{8,20}$/, 'Solo números, 8 a 20 dígitos')
        .nullable()
        .optional(),
    provinceCode: z.string().regex(/^\d$/).nullable().optional(),
    cantonCode: z
        .string()
        .regex(/^\d{2}$/)
        .nullable()
        .optional(),
    districtCode: z
        .string()
        .regex(/^\d{2}$/)
        .nullable()
        .optional(),
    addressDetail: z.string().trim().max(250).nullable().optional(),
    economicActivity: z
        .string()
        .regex(/^\d{4,6}(\.\d)?$/)
        .nullable()
        .optional(),
    defaultTerms: z.string().trim().max(4000).nullable().optional(),
    defaultCurrency: z.enum(['CRC', 'USD', 'EUR']).optional(),
});
export const createCompanyInput = withIdentificationCheck(companyBase);
export const updateCompanyInput = companyBase.partial();
//# sourceMappingURL=company.js.map